"use client";

import Image from "next/image";
import { motion } from "framer-motion";

export function AboutHero() {
  return (
    <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden pt-20">
      <Image
        src="/images/skydeck-nandi-hills-view.jpg"
        alt="Nest Villas — luxury holidays and experiences"
        fill
        priority
        className="object-cover"
        sizes="100vw"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/85 via-background/70 to-background" />
      <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent" />

      <div className="relative z-10 mx-auto max-w-4xl px-4 py-20 text-center md:px-8 md:py-24">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-sm font-medium uppercase tracking-[0.3em] text-primary"
        >
          About Us
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-5 font-playfair text-4xl font-bold leading-tight text-foreground md:text-6xl lg:text-7xl"
        >
          About <span className="text-primary">Nest Villas</span>
        </motion.h1>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mx-auto mt-8 flex w-fit items-center gap-3"
        >
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-primary/60 md:w-20" />
          <div className="size-1.5 rotate-45 bg-primary/80" />
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-primary/60 md:w-20" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg"
        >
          Luxury holidays and elevated experiences, thoughtfully crafted for those
          who seek privacy, beauty, and a true sense of escape.
        </motion.p>
      </div>
    </section>
  );
}
